var map = {
	"./app/background.jpg": 9915,
	"./app/button-appstore.svg": 1488,
	"./app/button-playstore.svg": 1345,
	"./app/frame_close1.png": 43,
	"./app/frame_close2.png": 1765,
	"./app/fw_map.jpg": 2363,
	"./app/ornam_oben.png": 3895,
	"./app/ornam_unten.png": 6730,
	"./app/parchment-frame.png": 1058,
	"./app/parchment-left.png": 5705,
	"./app/parchment-right.png": 8431,
	"./app/start_button.png": 4663,
	"./app/start_screen.jpg": 9539,
	"./content/fw_info_bg_verlauf_oben.png": 5075,
	"./content/fw_info_bg_verlauf_unten.png": 8407,
	"./content/page/fw_info1_b1.png": 7984,
	"./content/page/fw_info1_b2.png": 1675,
	"./content/page/fw_info1_b3.png": 2576,
	"./content/page/fw_info1_b4.png": 5382,
	"./content/page/fw_info2_b1.png": 7204,
	"./content/page/fw_info2_b3.png": 1913,
	"./content/page/fw_info3_b1.png": 5789,
	"./content/page/fw_info3_b2.png": 6370,
	"./content/page/fw_info3_b3.png": 4199,
	"./content/page/fw_info4_b1.png": 813,
	"./content/page/fw_info4_b2.png": 1621,
	"./content/page/fw_info4_b3.png": 9981,
	"./content/page/fw_info4_b4.png": 9588,
	"./content/page/fw_info4_b5.png": 9112,
	"./content/page/fw_info4_b6.png": 605,
	"./content/page/fw_info4_b7.png": 2457,
	"./content/page/fw_info5_b1.png": 4825,
	"./content/page/fw_info5_b2.png": 9477,
	"./content/page/fw_info5_b3.png": 4399,
	"./content/page/fw_info5_b4.png": 3842,
	"./content/page/fw_info5_b5.png": 9931,
	"./content/page/imprint/ELKB_zeichen-mit-schriftzug-rechts-HKS-37-K-4C.png": 1642,
	"./content/page/imprint/Hannover_evlka_WBM-V1_cmyk.png": 6131,
	"./content/page/imprint/logo_KIDS-interactive.png": 9224,
	"./content/page/imprint/logo_adult.png": 8366,
	"./content/page/imprint/logo_uni_greifswald.png": 9850,
	"./content/scroll_bar.png": 3664,
	"./content/scroll_track.png": 9803,
	"./fonts/gabriola.woff": 1222,
	"./fonts/morris-roman.woff": 9400,
	"./game-huds/background.png": 4330,
	"./game-huds/bible.png": 5508,
	"./game-huds/checkbox.png": 877,
	"./game-huds/checkbox_checked.png": 2536,
	"./game-huds/fw_ausw_s4_1.png": 7465,
	"./game-huds/fw_ausw_s4_2.png": 2304,
	"./game-huds/fw_ausw_s4_3.png": 7354,
	"./game-huds/fw_ausw_s4_4.png": 2126,
	"./game-huds/lightning.png": 2642,
	"./game-huds/pursue_distance.png": 5484,
	"./game-huds/pursued.png": 8932,
	"./game-huds/pursuer.png": 2274,
	"./global/default-button/btn_bg_part_left.svg": 9710,
	"./global/default-button/btn_bg_part_middle.svg": 5053,
	"./global/default-button/btn_bg_part_right.svg": 8673,
	"./global/default-button/next.png": 9036,
	"./global/default-button/repeat.png": 4848,
	"./global/default-button/skip.png": 7329,
	"./global/default-button/world.png": 991,
	"./global/error-modal/fw_ausw_popup_hg2.png": 8136,
	"./global/error-modal/kira.png": 4046,
	"./global/sound_off.png": 2269,
	"./global/sound_on.png": 5912,
	"./reusable/progress-icon/fw_ausw_lr1.png": 2352,
	"./reusable/progress-icon/fw_hs_l_rose.png": 74,
	"./reusable/rose-loader/blende_rose_layer1.png": 3682,
	"./reusable/rose-loader/blende_rose_layer2.png": 9487,
	"./reusable/rose-loader/blende_rose_layer3.png": 1131,
	"./reusable/rose-loader/blende_rose_layer4.png": 6718,
	"./reusable/rose-transition/blende_rose.png": 9341,
	"./world/end-screen/fw_ausw_info_hg.png": 7194,
	"./world/end-screen/fw_ausw_lr1.png": 2177,
	"./world/end-screen/fw_ausw_popup_hg_ohne_kira.png": 4650,
	"./world/end-screen/fw_ausw_popup_kira_super.png": 8976,
	"./world/fw_bg_l_schwer.png": 1747,
	"./world/fw_btn_leicht-without-text.png": 7052,
	"./world/fw_btn_schwer-without-text.png": 2318,
	"./world/fw_hs1.png": 5353,
	"./world/fw_hs1_glow.png": 9328,
	"./world/fw_hs2.png": 4215,
	"./world/fw_hs2_glow.png": 2381,
	"./world/fw_hs3.png": 3509,
	"./world/fw_hs3_glow.png": 3913,
	"./world/fw_hs4.png": 4034,
	"./world/fw_hs4_glow.png": 1352,
	"./world/fw_hs5.png": 8988,
	"./world/fw_hs5_glow.png": 6850,
	"./world/fw_hs_btn_i1.png": 1554,
	"./world/fw_hs_btn_i2.png": 1823,
	"./world/fw_hs_btn_i_close1.png": 4579,
	"./world/fw_hs_btn_i_close2.png": 9907,
	"./world/threads1.png": 2242,
	"./world/threads2.png": 6857,
	"./world/threads3.png": 9918,
	"./world/threads4.png": 3761,
	"./world/threads5.png": 9684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;